import React, { useEffect, useState } from 'react'
import { Button, Flex, Table, Typography, Space, Image, Row, Col, Form, Switch } from 'antd'
import { ActionButton, AlertModal, SearchInput } from '../../../components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi, TableLoader } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';

let timer;
const { Text } = Typography;
const Clienttable = () => {

    const navigate = useNavigate()
    const [deleteitem,setDeleteItem] = useState(false)
    const [ deletionLoading, setDeletionLoading]= useState(false)
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const { clientData, loadingclient, filters, pagination } = useSelector(state=>state.Clientgetapi)

    useEffect(()=>{
        dispatch(actionsApi?.getClientApi({ ...filters, ...pagination, pageNo: 1 }))
    },[])

    const call = (pageNo= 1, pageSize=10) => {
        dispatch(actionsApi?.getClientApi(...filters,pageNo, pageSize))
    }

    function searchHandler(name, pageNo=1, pageSize=20) {
        dispatch(actionsApi?.getClientApi({...filters, name, pageNo, pageSize}))
    }

    function debounce(func, delay) {
        return function(...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(searchHandler, 400)

    const onchange = (checked, row) => {
        const newStatus = checked ? 1 : 2
        dispatch(actionsApi?.clientstatusResponse({id: row?.id, status: newStatus}))
        dispatch(actionsApi?.updateClientStatus({id: row?.id, status: newStatus}))
    }

    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Client Name</Text>,
            dataIndex: 'firstName',
            render:(_,row) => `${row?.firstName} ${row?.lastName}`
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Phone Number</Text>,
            dataIndex: 'phoneNo'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Email</Text>,
            dataIndex: 'email'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Status</Text>,
            dataIndex: 'status',
            render: (status) => {
                if (status === 1) {
                    return <Text className='active fs-12 badge-cs'>Active</Text>;
                } else {
                    return <Text className='inactive fs-12 badge-cs'>Inactive</Text>;
                }
            },
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Registeration Date</Text>,
            dataIndex: 'date'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 150,
            render: (_, row) => (
                <Space>
                    <Switch size='small' 
                        checked={row?.status === 1}
                        onChange={(checked)=> onchange(checked,row)} 
                    />
                    <ActionButton
                        title='View Client'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {navigate(`/clients/detail/${row?.id}`)}}
                    />
                    <ActionButton
                        title='Delete Client'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.firstName, id: row?.id})}}
                    />
                </Space>
            ),
        },
    ];

    const DeleteClient = async() => {
        setDeletionLoading(true)
        const result = await apiCalls?.ClientPostApi?.DeleteClient(deleteitem?.id)
        if(result){
            setDeleteItem(null)
            searchHandler('')
        }
        setDeletionLoading(false)
    }

    return (
        <>
            <Flex vertical gap={20}>
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Row gutter={[16,16]} align={'middle'}>
                        <Col lg={8} md={12} sm={24} xs={24}>
                            <SearchInput 
                                name='name'
                                placeholder='Search client'
                                prefix={<img src='/assets/icons/search.png' width={20} />}
                                className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                                onChange={(e)=>debouncedSearchHandler(e.target.value, 1, 20)}
                            />
                        </Col>
                    </Row>
                </Form>
                <Table
                    size='large'
                    columns={columns}
                    dataSource={clientData}
                    className='pagination'
                    showSorterTooltip={false}
                    scroll={{ x: 1600 }}
                    pagination={{
                        hideOnSinglePage: true,
                        total: pagination?.totalRecords,
                        pageSize: pagination?.pageSize,
                        defaultPageSize: pagination?.pageSize,
                        current: pagination?.pageNo,
                        size: "default",
                        pageSizeOptions: ['10', '20', '50', '100'],
                        onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                        showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                    }}
                    loading = {
                        {
                            ...TableLoader,
                            spinning: loadingclient
                        }
                    }
                />
            </Flex>
            <AlertModal
                visible={deleteitem}
                deleteitem={deleteitem}
                callBack={DeleteClient}
                deletionLoading={deletionLoading}        
                onClose={()=>{setDeleteItem(false)}}
            />
        </>
    )
}

export { Clienttable }